module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/registered-vendors/registered-vendors.component.css
// module id = ./src/app/registered-vendors/registered-vendors.component.css
// module chunks = main